import React from 'react';
import { SectionHeader, Subtext } from './styled';

export function GroupBySectionHeader() {
  return (
    <>
      <SectionHeader>Group By</SectionHeader>
      <Subtext>
        Split out your aggregated data by one or more fields of your choosing.
      </Subtext>
    </>
  );
}
